const download = {
  CSVExport: (data, fileName, extension = ".csv") => {
    const encodedUri = encodeURIComponent(data)
    const csvDataForExport = "data:text/csv;charset=utf-8," + encodedUri
    const link = document.createElement("a")
    link.setAttribute("href", csvDataForExport)
    link.setAttribute("target", "_blank")
    link.setAttribute("download", fileName + extension)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },

  /**
   * Download a file from a remote URL (e.g. signed S3 export link).
   * @param {string} url
   * @param {string} [fileName]
   * @param {string} [extension]
   * @returns {Promise<void>}
   */
  downloadFromUrl: async (url, fileName = "export", extension = ".csv") => {
    const trimmedUrl = String(url ?? "").trim()
    if (!trimmedUrl) return

    const response = await fetch(trimmedUrl, {
      method: "GET",
      headers: { Accept: "*/*" }
    })

    if (!response.ok) {
      throw new Error(
        `Failed to download file: ${response.status} ${response.statusText}`
      )
    }

    const blob = await response.blob()
    const resolvedName =
      String(fileName ?? "").trim() ||
      trimmedUrl.split("/").pop()?.split("?")[0] ||
      "export"
    const downloadName = resolvedName.toLowerCase().endsWith(".csv")
      ? resolvedName
      : `${resolvedName}${extension}`

    const link = document.createElement("a")
    const objectUrl = URL.createObjectURL(blob)
    link.href = objectUrl
    link.setAttribute("download", downloadName)
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      URL.revokeObjectURL(objectUrl)
    }, 100)
  }
}

export default download
